import React from 'react';
import { X } from 'lucide-react';
import ddLogo from '../ui/dd.png';

const MobileHeader = ({ appName, isDarkMode, onClose }) => {
  return (
    <div className={`p-4 flex items-center justify-between ${
      isDarkMode ? 'bg-card-gradient backdrop-blur-sm' : 'bg-white'
    } border-b ${isDarkMode ? 'border-brand-border-logo' : 'border-gray-200'}`}>
      <div className="flex items-center space-x-3">
        <img src={ddLogo} alt="Logo" className="h-8 w-auto" />
        <h2 className={`font-bold text-lg ${
          isDarkMode ? 'text-white' : 'text-gray-900'
        }`}>
          {appName}
        </h2>
      </div>
      <button
        onClick={onClose}
        className={`p-2 rounded-full ${
          isDarkMode ? 'hover:bg-brand-logo-purple/10 text-gray-400 hover:text-brand-logo-purple' : 'hover:bg-gray-100'
        } transition-colors`}
        aria-label="Close menu"
      >
        <X size={20} className={isDarkMode ? 'text-brand-logo-purple' : 'text-gray-600'} />
      </button>
    </div>
  );
};

export default MobileHeader; 